"use client";

import { usePrevNextButtons } from "@/lib/usePrevNextButtons";
import { Box, Chip, Fade } from "@mui/material";
import useEmblaCarousel, { EmblaViewportRefType } from "embla-carousel-react";
import { PropsWithChildren, useEffect } from "react";
import MobileFilterColorChip from "./MobileFilterColorChip";
import MobileFilterBrandChip from "./MobileFilterBrandChip";
import MobileFilterInStockChip from "./MobileFilterInStockChip";
import MobileFilterHasOfferChip from "./MobileFilterHasOfferChip";
import MobileFilterPriceRangeChip from "./MobileFilterPriceRangeChip";
import { EmblaCarouselType } from "embla-carousel";
import MobileSearchedTextChip from "./MobileSearchedTextChip";
import { useSiteSearchContext } from "./SiteSearchContext";

type Props = {
  emblaRef: EmblaViewportRefType;
  emblaApi: EmblaCarouselType | undefined;
  nextBtnDisabled?: boolean;
  prevBtnDisabled?: boolean;
};

export default function MobileFilterChips(props: Props) {
  const { emblaApi, emblaRef, nextBtnDisabled, prevBtnDisabled } = props;
  const { brands } = useSiteSearchContext();

  // useEffect(() => {
  //   if (emblaApi) {
  //     // Embla API is ready
  //   }
  // }, [emblaApi]);

  return (
    <>
      {/* embla */}
      <Box sx={{ position: "relative" }}>
        {/*  embla__viewport */}
        <Box sx={{ overflow: "hidden", position: "relative" }} ref={emblaRef}>
          {/* embla__container */}
          <Box
            sx={{
              backfaceVisibility: "hidden",
              display: "flex",
              touchAction: "pan-y pinch-zoom",
            }}
          >
            <Box sx={{ pr: 1 }}>
              <MobileSearchedTextChip />
            </Box>
            <Box sx={{ pr: 1 }}>
              <MobileFilterColorChip />
            </Box>
            {brands && brands.length > 0 && (
              <Box sx={{ pr: 1 }}>
                <MobileFilterBrandChip />
              </Box>
            )}
            <Box sx={{ pr: 1 }}>
              <MobileFilterPriceRangeChip />
            </Box>
            <Box sx={{ pr: 1 }}>
              <MobileFilterInStockChip />
            </Box>
            <Box sx={{ pr: 1 }}>
              <MobileFilterHasOfferChip />
            </Box>
          </Box>
        </Box>
        <Fade in={!nextBtnDisabled}>
          <Box
            sx={(theme) => ({
              position: "absolute",
              display: "flex",
              alignItems: "center",
              right: 0,
              top: 0,
              height: "100%",
              width: "25px",
              zIndex: 1,
              background: `linear-gradient(90deg,  ${theme.palette.background.default},transparent)`,
            })}
          ></Box>
        </Fade>
        <Fade in={!prevBtnDisabled}>
          <Box
            sx={(theme) => ({
              position: "absolute",
              display: "flex",
              alignItems: "center",
              left: 0,
              top: 0,
              height: "100%",
              width: "25px",
              zIndex: 1,
              background: `linear-gradient(90deg, transparent,  ${theme.palette.background.default})`,
            })}
          ></Box>
        </Fade>
      </Box>
    </>
  );
}
